module.exports = __webpack_public_path__ + "img/map.20321326.png";